import { createClient } from '@supabase/supabase-js';
import { Database } from '../types/supabase';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient<Database>(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  db: {
    schema: 'public'
  }
});

// Set device_id in Supabase context
export const setDeviceId = async (deviceId: string): Promise<boolean> => {
  try {
    const { error } = await supabase.rpc('set_device_id', { device_id: deviceId });
    if (error) throw error;
    return true;
  } catch (error) {
    console.error('Error setting device_id:', error);
    return false;
  }
};

// Helper function to check database connection
export async function checkConnection() {
  try {
    const { data, error } = await supabase
      .from('shifts')
      .select('count')
      .single();

    if (error) {
      if (error.code === "42P01") {
        console.warn("Table 'shifts' does not exist yet");
        return false;
      }
      throw error;
    }
    console.log('Supabase connection successful');
    return true;
  } catch (error) {
    console.error('Supabase connection error:', error);
    return false;
  }
}